import { render, staticRenderFns } from "./AdminBaseAiModels.vue?vue&type=template&id=73da01b0"
import script from "./AdminBaseAiModels.vue?vue&type=script&lang=js"
export * from "./AdminBaseAiModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports